import { render, staticRenderFns } from "./ModalEditFields.vue?vue&type=template&id=2222dbfd&scoped=true&lang=html&"
import script from "./ModalEditFields.vue?vue&type=script&lang=js&"
export * from "./ModalEditFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222dbfd",
  null
  
)

export default component.exports